import { Form } from '@unform/web';
import styled, { css } from 'styled-components';

interface ButtonTabsProps {
  isFocused: boolean;
}

export const Container = styled(Form)`
  width: 100%;
`;
export const Title = styled.h2`
  color: #1976d2;
  margin: 20px 0px;
`;
export const Adicional = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TabMontagemTop = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;

  padding-right: 100px;
  padding-left: 100px;
`;
export const TabMontagemBottom = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;

  padding-right: 100px;
  padding-left: 100px;
`;
export const TabMontagem = styled.div`
  flex-wrap: wrap;
`;
export const TabAdicionais = styled.div`
  place-content: center;
  margin: 16px 8px;
  background-color: #fbfbfb;

  .react-grid-Grid {
    margin-bottom: 8px;
    user-select: text;
  }

  .react-grid-Cell__value {
    padding: 8px 0px;
  }

  input {
    width: 100%;
    padding: 4px;
    border: 1px solid #bbb;
    border-radius: 8px;
  }

  button {
    border: 1px solid #2c73e9 !important;
    border-radius: 8px;
    color: #2c73e9 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
  }
`;
export const ButtonTabs = styled.button<ButtonTabsProps>`
  border: none;
  padding: 5px;
  background-color: #fff;
  color: #1976d2;
  ${(props) =>
    props.isFocused &&
    css`
      background-color: #1976d2;
      color: #fff;
    `}
`;
